import { RootState } from "@/store/store";
import { explainWithAIDataSelector } from "@/store/explain-with-ai/selectors/data/summary-data/explainWithAIDataSelector";

export const explainWithAiDataAnomaliesSelector = (
  state: RootState,
  index: number,
) => {
  return explainWithAIDataSelector(state, index)?.anomalies;
};
